export const BIG_BAG_TYPE_WITH_MAWB = 1 as const;
export const BIG_BAG_TYPE_NO_MAWB = 0 as const;

export type BigBagType = typeof BIG_BAG_TYPE_WITH_MAWB | typeof BIG_BAG_TYPE_NO_MAWB;

/** 下钻上下文：null 表示包裹明细合并查询两种大包类型（与 KPI / 客户行包裹差异汇总一致） */
export type BigBagDrilldownBagType = BigBagType | null;

